module.exports = __webpack_public_path__ + "static/face.b6a648f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/face.jpg
// module id = 122
// module chunks = 35783957827783 170384593892729